import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { HOSPITOL_HD_CONFIG } from "./hospitol-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface HospitolProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** Hospitol HD — shared ProductDetailHdPage + medical-team hero assets. */
export function HospitolProductDetailHd(props: HospitolProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={HOSPITOL_HD_CONFIG} />;
}
